import { Button } from 'components/ui/buttons'
import ModalDialog from 'components/ui/modal-dialog'
import Text from 'components/ui/text'
import { isFreeTrialUsed } from 'utils/freeVersionBlock'
import { translate } from 'utils/translation'
import { isSignedIn } from 'utils/userAuth'
import { formatNumber } from 'utils/numbers'

import { PaywallType } from '../types'
import { paywallMessages } from '../constants/messages'

interface PaywallModalProps {
  type: PaywallType
  isOpen: boolean
  descriptionVariable: number | null
  onClose: VoidFunction
  onClickPrimary: VoidFunction
  onClickLink: VoidFunction
}

const PaywallModal = ({
  type,
  isOpen,
  descriptionVariable,
  onClose,
  onClickPrimary,
  onClickLink,
}: PaywallModalProps) => {
  const isUserSignedIn = isSignedIn()
  const freeTrialUsed = isFreeTrialUsed()

  const messageType =
    !isUserSignedIn || !freeTrialUsed ? 'freeTrialEligible' : 'notEligible'

  return (
    <ModalDialog
      isOpen={isOpen}
      onClose={onClose}
      variant="center"
      title={paywallMessages[type].title[messageType]}
      titleClassName="tw-mt-0 tw-font-normal tw-max-w-xs"
      titleVariables={paywallMessages[type].title.variables}
      content={
        <div>
          <hr className="tw-border-orange tw-w-14 tw-my-0 tw-border-0 tw-border-b" />
          <Text
            className="tw-mt-6 tw-mb-2 tw-text-base tw-tracking-wide"
            translationVariables={[formatNumber(descriptionVariable ?? 9999)]}
          >
            {paywallMessages[type].description[messageType]}
          </Text>
        </div>
      }
      footer={
        <div className="tw-flex tw-flex-col tw-gap-6">
          <div className="tw-flex tw-flex-col tw-gap-2">
            <Button variant="legacy" onClick={onClickPrimary}>
              {translate(paywallMessages[type].button[messageType])}
            </Button>
            <Button variant="legacySecondary" size="lg" onClick={onClose}>
              {translate('no_thanks')}
            </Button>
          </div>
          {!isUserSignedIn && (
            <div className="tw-flex tw-w-full tw-justify-center tw-gap-1">
              <Text className="tw-text-sm tw-text-zinc-800" as="span">
                have_subscription
              </Text>
              <Button variant="onlyText" onClick={onClickLink}>
                <Text as="span" className="tw-text-orange tw-underline">
                  sign_in_here
                </Text>
              </Button>
            </div>
          )}
        </div>
      }
    />
  )
}

export default PaywallModal
